import { MetricCard, MetricGrid, useShell } from "@nymbl/nos2-rules";
import { attentionTiles, type HomeAlerts } from "@/lib/month/metrics";
import { formatHours } from "@/lib/time/rules";

/** Only what needs doing (DECISIONS: alerts only when actionable); nothing at 0. */
export function AttentionTiles({ alerts }: { alerts: HomeAlerts | null }) {
  const { Link } = useShell();
  const tiles = attentionTiles(alerts);
  if (tiles.length === 0) return null;
  return (
    <section aria-label="Needs attention">
      <MetricGrid>
        {tiles.map((t) =>
          t.kind === "weeks" ? (
            <MetricCard
              key={t.kind}
              label="To sign off"
              value={`${t.value} ${t.value === 1 ? "week" : "weeks"}`}
              alert
              alertLabel="Overdue"
              href="/dashboard/time"
              Link={Link}
            />
          ) : (
            <MetricCard
              key={t.kind}
              label="Missing"
              value={`${formatHours(t.value)} hrs`}
              alert
              alertTone="warning"
              alertLabel="Needs time"
              href="/dashboard/time"
              Link={Link}
            />
          ),
        )}
      </MetricGrid>
    </section>
  );
}
